/** Форматирование для интерфейса. Ничего доменного здесь нет. */

/** Время события ленты. «—» на нечитаемой отметке: битое поле не должно ломать строку. */
export function formatTime(ts: string): string {
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleTimeString("ru-RU");
}

/** Возраст в человеческом виде: «3 с», «1 мин 20 с», «> 1 ч». */
export function formatAge(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return "—";
  const sec = Math.floor(ms / 1000);
  if (sec < 60) return `${sec} с`;
  if (sec < 3600) {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return s === 0 ? `${m} мин` : `${m} мин ${s} с`;
  }
  return "> 1 ч";
}

/** Укороченный идентификатор: «0x12345678…». */
export function shortId(id: string, n = 10): string {
  return id.length <= n ? id : `${id.slice(0, n)}…`;
}

/**
 * Русское склонение существительного при числе: «1 кошелёк», «2 кошелька»,
 * «121 кошелёк», «115 кошельков».
 *
 * Нужно потому, что интерфейс русский, а «121 кошельков» читается как опечатка —
 * то есть заставляет усомниться в числе рядом. Правило: последние ДВЕ цифры
 * решают раньше последней (11–14 всегда множественное), иначе «111 кошелёк».
 */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(Math.trunc(n));
  const lastTwo = abs % 100;
  if (lastTwo >= 11 && lastTwo <= 14) return many;
  switch (abs % 10) {
    case 1:
      return one;
    case 2:
    case 3:
    case 4:
      return few;
    default:
      return many;
  }
}

/**
 * Момент и давность одной строкой: «10.10, 14:32 · 5 мин назад».
 *
 * Дата видна сразу, а не в подсказке: оператор сверяет её с профилем биржи, и
 * одно «5 мин назад» не говорит, о каких сутках речь. «—» на пустой или битой
 * отметке — данных нет, а не «только что».
 */
export function formatStamp(ts: string | null | undefined, now: number): string {
  if (!ts) return "—";
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return "—";
  const at = d.toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  const min = Math.floor(Math.max(0, now - d.getTime()) / 60_000);
  let ago: string;
  if (min < 1) ago = "только что";
  else if (min < 60) ago = `${min} мин назад`;
  else if (min < 48 * 60) ago = `${Math.floor(min / 60)} ч назад`;
  else ago = `${Math.floor(min / 1440)} дн назад`;
  return `${at} · ${ago}`;
}
